





































import {Component, Vue} from "vue-property-decorator";
import LadingSelector from "@/shared/components/LadingSelector/index.vue";
import {LadingStatus} from "@/enums/status";
import {FormModel} from "ant-design-vue";
import {LadingCareStore} from "@/modules/ladingcare/store";

@Component({
    name: "LadingCareCreate",
    components: {LadingSelector}
})
export default class extends Vue {
    LadingStatus = LadingStatus
    
    private form = {
        ladingCode: "",
        note: ""
    };
    private rules = {
        ladingCode: [{required: true, message: "Nhập mã vận đơn", trigger: "change"}],
        note: [{required: true, message: "Nhập nội dung yêu cầu", trigger: "change"}]
    }
    

    private onSubmit() {
        (this.$refs.formLadingCare as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                await LadingCareStore.createLadingCare(this.form)
                this.$notification.success({
                    message: "Thành công",
                    description: `Tạo đơn yêu cầu thành công`
                });
                
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || 'Tạo đơn yêu cầu thất bại'}`
                })
            }
            
        })
    }
}


